@for (type of openedModals(); track type) {
    <div
        #modalElement
        class="map-modal"
        [attr.data-modal-type]="type"
        [class.is-auto-moving]="mapModalService.isAutoMoving()"
        [class.is-dragging]="isDragging(type)"
        [class.is-hidden]="mapModalService.areModalsHidden()"
        [style.left.px]="mapModalService.state()[type].position.x"
        [style.top.px]="mapModalService.state()[type].position.y"
        (pointerdown)="onPointerDown($event, type)">
        <div class="flex flex-row items-center h-full w-full">
            <fa-icon
                class="m-1 text-custom-dark-grey"
                [icon]="['fas', 'grip-vertical']" />
            <div>
                @if (modalComponentByType[type]) {
                    <ng-container *ngComponentOutlet="modalComponentByType[type]" />
                }
            </div>
        </div>
    </div>
}
